module.exports = __webpack_public_path__ + "Roboto-Italic.woff2?4357beb823a5f8d65c260f045d9e019a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/Italic/Roboto-Italic.woff2?v=2.137
// module id = 193
// module chunks = 7